module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-einkehren"
  }, [_c('header', {
    staticClass: "hero--index"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "biere"
    }
  }, [_c('span', [_vm._v("Erkunde Zissel")])])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "hero-heading"
  }, [_c('small', [_vm._v("Braukunst aus Oberfranken")]), _vm._v("\n            Zissel\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--interlude"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-8"
  }, [_c('h2', [_vm._v("Kultige Atmosphäre")]), _vm._v(" "), _c('p', [_vm._v("in einer typischen Gasthausbrauerei\n                        und fränkische Küche: "), _c('b', [_vm._v("Zissel verbindet.")])]), _vm._v(" "), _c('p', [_vm._v("\n                        Nach einer sportlichen Fahrradtour durch das Frankenland, einer Wanderung\n                        oder wann immer Sie mögen:\n                        Kehren Sie bei uns ein – in unseren Biergarten,\n                        in den kühlen Braukeller oder in unsere neue Erlebniskneipe. Hier fühlt man sich wohl!\n                    ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "slider-item"
  }, [_c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-1.jpg",
      "alt": "Anwesen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider-text"
  }, [_c('h2', [_vm._v("Unsere Privatbrauerei\n                        "), _c('small', [_vm._v("\n                            am Rande von Kulmbach besteht seit 1898.\n                        ")])]), _vm._v(" "), _c('p', [_vm._v("Zum Anwesen gehören Brauerei, Gaststätte mit Biergarten,\n                        Brennerei und ein Gästehaus.")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider-item"
  }, [_c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-2.jpg",
      "alt": "Brauen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider-text"
  }, [_c('h2', [_vm._v("Unsere Qualitätsbiere\n                        "), _c('small', [_vm._v("\n                            werden mit Wasser aus eigenem\n                            Tiefbrunnen nach dem Bayerischen Reinheitsgebot gebraut.\n                        ")])]), _vm._v(" "), _c('p', [_vm._v("Probieren Sie das erfrischend herbe Helle, das untergärige Dunkle,\n                        unser Rauchbier oder unser Ungespundetes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider-item"
  }, [_c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-3.jpg",
      "alt": "Gerichte"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider-text"
  }, [_c('h2', [_vm._v("Und weil zu fränkischem Bier\n                        "), _c('small', [_vm._v("\n                            nun mal nichts so\n                            gut passt wie die echte fränkische Küche,\n                            servieren wir regional typische und köstliche Gerichte.\n                        ")])]), _vm._v(" "), _c('p', [_vm._v("Auf Ihr Wohl!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09ca3cae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/einkehren.vue
// module id = 28
// module chunks = 0